import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import { useDispatch } from 'react-redux';
import DTCustomerDetailsFormView from '../../DTCustomerDetailsFormView';

const DTAddCustomerDetailsForItemReplacementNode = () => {
  const dispatch = useDispatch();

  const onNextButtonClick = () => {
    dispatch(addEdgeToDecisionTreePath('details_filled'));
  };

  return <DTCustomerDetailsFormView onNextButtonClick={onNextButtonClick} />;
};

export default DTAddCustomerDetailsForItemReplacementNode;
